/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectData } from './businessObjectData';


export interface UploadSingleInitiationResponse { 
    sourceBusinessObjectData: BusinessObjectData;
    targetBusinessObjectData: BusinessObjectData;
    file: Blob;
    /**
     * The UUID generated for this upload
     */
    uuid: string;
    /**
     * The AWS access key that must be used to upload to this object in S3
     */
    awsAccessKey: string;
    /**
     * The AWS secret key that must be used to upload to this object in S3
     */
    awsSecretKey: string;
    /**
     * The AWS session token that must be used to upload to this object in S3
     */
    awsSessionToken: string;
    /**
     * The timestamp of when the provided AWS credentials will expire
     */
    awsSessionExpirationTime: Date;
    /**
     * The KMS key ID that must be used to do SSE
     */
    awsKmsKeyId: string;
    /**
     * The target storage name
     */
    targetStorageName: string;
}
